// Holding screen for sections still being rebuilt.
// Swap back to the real component in App.js once the section is ready.
export default function UnderConstruction({ section = "This section", onGo }) {
  const stripe = {
    height: 14,
    background: "repeating-linear-gradient(-45deg, #f5c800 0 18px, #0a0a0a 18px 36px)",
  };
  const btn = {
    padding: "12px 16px",
    background: "transparent",
    border: "1px solid #dc2626",
    borderRadius: 6,
    color: "#fff",
    cursor: "pointer",
    fontFamily: "'Impact','Arial Black',sans-serif",
    fontSize: 13,
    letterSpacing: "0.08em",
  };

  return (
    <div style={{ background: "#050505", minHeight: "70vh", color: "#e2e8f0", fontFamily: "'Courier New',monospace" }}>
      <div style={stripe} />
      <div style={{ maxWidth: 560, margin: "0 auto", padding: "48px 20px", textAlign: "center" }}>
        <div style={{ fontSize: 56, lineHeight: 1 }} aria-hidden="true">🚧🧪</div>

        <div style={{ marginTop: 18, fontSize: 11, color: "#dc2626", letterSpacing: "0.3em" }}>
          {section.toUpperCase()}
        </div>

        <h1 style={{
          margin: "8px 0 0",
          fontFamily: "'Impact','Arial Black',sans-serif",
          fontSize: 38,
          lineHeight: 1.05,
          color: "#f5c800",
          letterSpacing: "0.06em",
          textShadow: "2px 2px 0 #7f1d1d",
        }}>
          UNDER CONSTRUCTION
        </h1>

        <p style={{ margin: "18px 0 0", fontSize: 18, color: "#fff", fontWeight: 700 }}>
          The Mad Scientist is swamped.
        </p>

        <p style={{ margin: "14px auto 0", maxWidth: 440, fontSize: 13, lineHeight: 1.7, color: "#94a3b8" }}>
          This section is back on the bench while it gets rebuilt properly. It'll return when it's
          up to standard. In the meantime, the rest of the Vault is open.
        </p>

        {onGo && (
          <div style={{ marginTop: 28, display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
            <button style={btn} onClick={() => onGo("bible")}>📖 OPEN THE BIBLE</button>
            <button style={btn} onClick={() => onGo("bio")}>📊 BIOAVAILABILITY</button>
          </div>
        )}

        <div style={{ marginTop: 32, fontSize: 11, color: "#475569", letterSpacing: "0.1em" }}>
          — Greg "Mad Scientist 5150" Nikolettos
        </div>
      </div>
      <div style={stripe} />
    </div>
  );
}
